import React from 'react';

interface JackpotDetailsSectionProps {
  title: string;
  children: React.ReactNode;
}

export const JackpotDetailsSection: React.FC<JackpotDetailsSectionProps> = ({
  title,
  children
}) => {
  return (
    <div className="jackpot-popup-content-holder">
      <h2 className="jackpot-popup-content-title">{ title }</h2>
      { children }
    </div>
  );
};
